import { getSiteFeatureBoundRefProvider } from '../../utils/refProvider'
import type { LightboxRefs } from './types'

const featureName = 'lightbox'
const lightboxSiteRefProvider = getSiteFeatureBoundRefProvider(featureName)

const lightboxRefs: LightboxRefs = {
	lightboxPageId: () => lightboxSiteRefProvider(['lightboxPageId']),
}
export { lightboxRefs }
